import { getBusinessData } from '../utils';

import type { AddPresetScope } from '../../../../addPresetApiEntry';
import type { AiHtmlSectionUIApi } from '#packages/aiHtmlSectionCreator';

export type AiHtmlSectionCreatorStateProps = ReturnType<
  AiHtmlSectionUIApi['getAiHtmlSectionStateProps']
>;

export interface AiHtmlSectionCreatorDispatchProps {
  handleFormSubmit: (userInstruction: string) => Promise<void>;
}

export const mapStateToProps = (
  scope: AddPresetScope,
): AiHtmlSectionCreatorStateProps => {
  return scope.aiHtmlSectionUIApi.getAiHtmlSectionStateProps();
};

export const mapDispatchToProps = (
  scope: AddPresetScope,
): AiHtmlSectionCreatorDispatchProps => {
  const { businessType, businessName, toneOfVoice } = getBusinessData(scope);
  const { handleAiHtmlFormSubmit } =
    scope.aiHtmlSectionUIApi.getAiHtmlSectionDispatchProps();

  return {
    handleFormSubmit: (userInstruction: string) =>
      handleAiHtmlFormSubmit(
        {
          businessType,
          businessName,
          toneOfVoice,
          userInstruction,
          // todo: pass allowedComponents from the htmlToWix
          allowedComponents: 'div, span, p, h1, h2, button, img',
        },
        'site_generator_ai_section_santa',
      ),
  };
};
